import { createApi } from '@reduxjs/toolkit/query/react';
import baseApi from './base';

import { envConfig } from 'config';
import paginationParams from 'utils/pagination-params';

export const list = 'LIST_RESUME_PROFILES';
export const single = 'SINGLE_RESUME_PROFILE';

export const resumeProfilesApi = createApi({
  reducerPath: 'resumeProfilesApi',
  baseQuery: baseApi,
  tagTypes: [list, single],
  endpoints: (builder) => ({
    testResumeProfile: builder.mutation({
      query: (args) => ({
        url: `${envConfig.streamLambdaUrl}/resume-profiles/test`,
        method: 'POST',
        body: {
          s3Key: args.s3Key,
          prompts: args.prompts,
          resumeJson: args.resumeJson
        }
      })
    }),
    createResumeProfile: builder.mutation({
      query: (resumeProfile) => ({
        url: '/resume-profiles/create',
        method: 'POST',
        body: resumeProfile
      }),
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          const { data: created } = await queryFulfilled;
          dispatch(
            resumeProfilesApi.util.updateQueryData('listResumeProfiles', undefined, (draft) => {
              draft.data.items.unshift(created.data);
            })
          );
        } catch (err) {
          console.error('Error updating cache:', err);
        }
      }
    }),
    updateResumeProfile: builder.mutation({
      query: ({ resumeProfileId, ...attributes }) => ({
        url: `/resume-profiles/update/${resumeProfileId}`,
        method: 'POST',
        body: { ...attributes }
      }),
      invalidatesTags: [single],
      async onQueryStarted({ resumeProfileId }, { dispatch, queryFulfilled }) {
        try {
          const { data: updated } = await queryFulfilled;
          dispatch(
            resumeProfilesApi.util.updateQueryData('listResumeProfiles', undefined, (draft) => {
              const item = draft.data.items.find((profile) => profile.id === resumeProfileId);
              if (item) {
                Object.assign(item, updated.data);
              }
            })
          );
        } catch (err) {
          console.error('Error updating cache:', err);
        }
      }
    }),
    deleteResumeProfile: builder.mutation({
      query: (resumeProfileId) => ({
        url: `/resume-profiles/delete/${resumeProfileId}`,
        method: 'DELETE'
      }),
      async onQueryStarted(id, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
          dispatch(
            resumeProfilesApi.util.updateQueryData('listResumeProfiles', undefined, (draft) => {
              const idx = draft.data.items.findIndex((item) => item.id === id);
              if (idx > -1) {
                draft.data.items.splice(idx, 1);
              }
            })
          );
        } catch (err) {
          console.error('Error updating cache:', err);
        }
      }
    }),
    getResumeProfileById: builder.query({
      query: (resumeProfileId) => `/resume-profiles/get/${resumeProfileId}`,
      providesTags: [single]
    }),
    listResumeProfiles: builder.query({
      query: (params) => ({
        url: '/resume-profiles/list',
        params
      }),
      providesTags: [list],
      ...paginationParams
    })
  })
});

export const {
  useTestResumeProfileMutation,
  useCreateResumeProfileMutation,
  useUpdateResumeProfileMutation,
  useDeleteResumeProfileMutation,
  useGetResumeProfileByIdQuery,
  useListResumeProfilesQuery
} = resumeProfilesApi;
